/* 4U SMART CART (v5)

   A) FREE GIFT (no app needed)
      Hidden $0 product "Free Gift: 4U Lifting Straps" (GIFT_VARIANT) is
      added automatically once the cart TOTAL, after every discount
      (automatic discounts + discount codes), reaches GIFT_THRESHOLD, and
      removed automatically the moment the total drops below it. Always max 1.
      Also removes any regular $40 straps that an old gift app slipped in.

   B) SMART UPSELL
      Replaces the theme's "You may also like" block with the offer most
      likely to raise order value, based on what's in the cart.

   C) SAFETY NET
      The theme's own Remove / quantity code runs untouched. Only when
      Shopify rejects a change (stale line, busy) do we step in and fix it
      quietly, so there are never popups, redirects or stuck spinners.

   Draft/preview themes show a small cart log in the drawer for testing.
   Add ?fuoff=1 to any URL to run the theme with none of this code. */
(function(){
  if (window.__fuUpsellInit) return;
  window.__fuUpsellInit = true;
  if (/[?&]fuoff=1/.test(location.search)) return;

  var GIFT_VARIANT = 56061076996264;
  var GIFT_HANDLE = 'free-gift-4u-lifting-straps';
  var GIFT_THRESHOLD = 25000;
  var STRAPS_HANDLE = '4u-lifting-straps';

  var H = {
    mesh: 'core-4-mesh-shorts',
    tank: 'essentials-tank',
    tee: 'conquer-compression-tee',
    ls: 'conquer-compression-long-sleeve',
    shorts: 'conquer-mens-activewear-shorts'
  };
  var MIX = [H.tee, H.ls, H.shorts];
  var MIX_TIERS = { 2: 10, 3: 15, 4: 20 };
  var MESH_TANK_OFF = 2500;
  var FREE_SHIP = 12000;

  var CSS = '' +
    '.fu-up{padding:14px 0 6px;border-top:1px solid #efefef;margin-top:4px;width:100%;box-sizing:border-box;}' +
    '.fu-up-title{margin:0 0 10px;font-size:14px;font-weight:700;color:#111;letter-spacing:.01em;}' +
    '.fu-up-card{display:flex;gap:12px;padding:12px;border:1px solid #ececec;border-radius:12px;background:#fff;margin-bottom:10px;}' +
    '.fu-up-img{flex:0 0 72px;width:72px;height:90px;border-radius:8px;overflow:hidden;background:#f2f2f2;display:block;}' +
    '.fu-up-img img{width:100%;height:100%;object-fit:cover;object-position:center top;display:block;}' +
    '.fu-up-info{flex:1;min-width:0;display:flex;flex-direction:column;gap:4px;}' +
    '.fu-up-tag{align-self:flex-start;font-size:9.5px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#fff;background:#c2410c;border-radius:4px;padding:3px 6px;line-height:1;}' +
    '.fu-up-name{font-size:13px;font-weight:700;color:#111;text-decoration:none;line-height:1.25;}' +
    '.fu-up-price{display:flex;align-items:baseline;gap:6px;font-size:13px;}' +
    '.fu-up-price s{color:#9a9a9a;font-weight:400;}' +
    '.fu-up-price b{color:#111;font-weight:700;}' +
    '.fu-up-msg{font-size:11.5px;font-weight:600;color:#166534;line-height:1.35;}' +
    '.fu-up-ship{font-size:11px;color:#6b6b6b;line-height:1.3;}' +
    '.fu-up-ship:empty{display:none;}' +
    '.fu-up-row{display:flex;flex-wrap:wrap;gap:6px;margin-top:4px;}' +
    '.fu-up-row select{flex:1 1 92px;min-width:92px;height:34px;border:1px solid #e2e2e2;border-radius:999px;padding:0 10px;font:inherit;font-size:12px;background:#fff;color:#111;}' +
    '.fu-up-add{flex:1 0 70px;height:34px;padding:0 16px;border:0;border-radius:999px;background:#111;color:#fff;font:inherit;font-size:12.5px;font-weight:600;cursor:pointer;}' +
    '.fu-up-add[disabled]{opacity:.5;cursor:default;}' +
    '.fu-up-add.is-done{background:#166534;}' +
    '.fu-up-err{font-size:11px;color:#b91c1c;}' +
    '.fu-up-err:empty{display:none;}' +
    '.fu-up-hidden{display:none !important;}';

  function injectCss(){
    if (document.getElementById('fu-up-css')) return;
    var s = document.createElement('style');
    s.id = 'fu-up-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function money(c){ return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  var PJ = {};
  function getP(h){
    if (!PJ[h]) {
      PJ[h] = fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return PJ[h];
  }
  function getCart(){
    return fetch('/cart.js?fu=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function(r){ return r.json(); });
  }
  function postJSON(url, body){
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-FU': '1' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(r.status + ' ' + (j.description || j.message || 'Cart error')); return j; }); });
  }
  function optIdx(p, re){
    var o = p.options || [];
    for (var i = 0; i < o.length; i++) { var n = typeof o[i] === 'string' ? o[i] : (o[i].name || ''); if (re.test(n)) return i; }
    return -1;
  }
  function isGift(it){ return it.variant_id === GIFT_VARIANT || it.handle === GIFT_HANDLE; }
  function isAppStraps(it){
    if (it.handle !== STRAPS_HANDLE || !it.properties) return false;
    for (var k in it.properties) { if (/gift|auto|eg_|aiod|free/i.test(k + ' ' + it.properties[k])) return true; }
    return false;
  }

  /* ---------- shared cart state ---------- */
  var lastCart = null;
  function isCart(c){ return c && c.items && typeof c.total_price === 'number'; }
  function setCart(c){ if (isCart(c)) lastCart = c; }
  function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
  function bundled(){
    var s = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: s } })); } catch (e) {}
    return s.filter(function(x, i){ return x && s.indexOf(x) === i; });
  }
  function drawerOpen(){
    var d = document.querySelector('cart-drawer');
    return !!(d && (d.open || d.hasAttribute('open')));
  }
  function swapSections(json){
    var sec = json && json.sections; if (!sec) return;
    Object.keys(sec).forEach(function(id){
      if (!sec[id]) return;
      var doc = new DOMParser().parseFromString(sec[id], 'text/html');
      ['MiniCart-', 'MainCart-'].forEach(function(pre){
        var cur = document.getElementById(pre + id), fresh = doc.getElementById(pre + id);
        if (cur && fresh) cur.innerHTML = fresh.innerHTML;
      });
    });
  }
  function publishCart(json){
    setCart(json);
    if (json && json.sections) {
      if (drawerOpen() && window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
        try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fu-cart', cart: json }); } catch (e) { swapSections(json); }
      } else {
        swapSections(json);
      }
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: json } })); } catch (e) {}
    }
    scheduleUpsell();
  }
  function cartUpdate(updates){
    lastNet = Date.now();
    var body = { updates: updates || {} };
    var sec = bundled(); if (sec.length) body.sections = sec;
    return postJSON('/cart/update.js', body);
  }
  function refreshCart(){
    return cartUpdate({}).then(function(j){ publishCart(j); return j; }).catch(function(){ return null; });
  }

  /* ---------- A) free gift ---------- */
  var giftBusy = false, queued = null, tries = {}, giftLog = [], lastGiftAdd = 0;
  function note(msg){ giftLog.push(new Date().toTimeString().slice(3,8) + ' ' + msg); if (giftLog.length > 8) giftLog.shift(); if (window.console) console.warn('[4U cart]', msg); showGiftDebug(); }
  function giftPlan(cart){
    var gifts = cart.items.filter(isGift);
    var junk = cart.items.filter(isAppStraps);
    var others = cart.items.filter(function(i){ return !isGift(i) && !isAppStraps(i); });
    var giftQty = gifts.reduce(function(s, i){ return s + i.quantity; }, 0);
    var junkValue = junk.reduce(function(s, i){ return s + (i.final_line_price || 0); }, 0);
    var qualifies = others.length > 0 && (cart.total_price - junkValue) >= GIFT_THRESHOLD;
    var sig = cart.total_price + '|' + others.map(function(i){ return i.variant_id + 'x' + i.quantity; }).sort().join(',');
    var upd = {}, n = 0;
    junk.forEach(function(j){ upd[j.key] = 0; n++; });
    if (!qualifies) gifts.forEach(function(g){ upd[g.key] = 0; n++; });
    else if (giftQty > 1) gifts.forEach(function(g, i){ upd[g.key] = i === 0 ? 1 : 0; n++; });
    if (n) return { kind: 'fix', updates: upd, sig: sig };
    if (qualifies && giftQty === 0) {
      var a = {}; a[GIFT_VARIANT] = 1;
      return { kind: 'add', updates: a, sig: sig };
    }
    return null;
  }
  function syncGift(cart){
    setCart(cart);
    if (!isCart(cart)) return;
    if (giftBusy) { queued = cart; return; }
    var plan = giftPlan(cart);
    if (!plan) { scheduleUpsell(); return; }
    var k = plan.kind + '|' + plan.sig;
    tries[k] = (tries[k] || 0) + 1;
    if (tries[k] > 2) {
      if (plan.kind === 'add' && tries[k] === 3) note(lastGiftAdd ? 'gift was added but something else keeps removing it' : 'gift could not be added');
      scheduleUpsell();
      return;
    }
    giftBusy = true;
    note('gift ' + plan.kind + ' (total $' + (cart.total_price / 100) + ')');
    cartUpdate(plan.updates).then(function(json){
      if (plan.kind === 'add') {
        if (json.items && json.items.some(isGift)) { lastGiftAdd = Date.now(); note('gift added OK'); }
        else note('Shopify accepted the add but the gift is not in the cart');
      }
      giftBusy = false;
      publishCart(json);
      var next = queued || json; queued = null;
      syncGift(next);
    }).catch(function(e){
      giftBusy = false;
      note('gift ' + plan.kind + ' failed: ' + (e && e.message));
      var q = queued; queued = null;
      if (q) syncGift(q);
    });
  }
  function showGiftDebug(){
    var isPreview = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main';
    if (!isPreview || !giftLog.length) return;
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var box = d.querySelector('.fu-gift-debug');
    if (!box) {
      var host = d.querySelector('cart-items');
      if (!host) return;
      box = document.createElement('div');
      box.className = 'fu-gift-debug';
      box.style.cssText = 'margin:8px 0;padding:8px 10px;border:1px dashed #b91c1c;border-radius:8px;font:11px/1.35 monospace;color:#b91c1c;background:#fff5f5;word-break:break-word;';
      host.insertBefore(box, host.firstChild);
    }
    box.textContent = 'PREVIEW ONLY (customers never see this). Cart log: ' + giftLog.join('  |  ');
  }

  /* ---------- B) upsell ---------- */
  function decide(cart){
    var qty = {}, sizes = [], colours = {};
    cart.items.forEach(function(it){
      if (isGift(it)) return;
      qty[it.handle] = (qty[it.handle] || 0) + it.quantity;
      (it.options_with_values || []).forEach(function(o){
        if (/size/i.test(o.name)) sizes.push(o.value);
        if (/colou?r/i.test(o.name)) colours[it.handle] = colours[it.handle] || o.value;
      });
    });
    var mixQty = MIX.reduce(function(s, h){ return s + (qty[h] || 0); }, 0);
    var anyColour = null;
    for (var k in colours) { anyColour = colours[k]; break; }
    var ctx = { size: sizes[0] || null, sub: cart.items_subtotal_price };
    var offers = [];
    if ((qty[H.mesh] || 0) > 0 && !(qty[H.tank] > 0)) {
      offers.push({ handle: H.tank, kind: 'meshTank', tag: 'Bundle deal', msg: 'Save $25 on the tank with your Mesh Shorts', colour: colours[H.mesh] });
    }
    var t = qty[H.tank] || 0;
    if (t > 0 && t % 3 !== 0) {
      var need = 3 - (t % 3);
      offers.push({ handle: H.tank, kind: need === 1 ? 'tankFree' : 'tankTwo', tag: need === 1 ? 'Free tank' : 'Buy 2 get 1 free',
        msg: need === 1 ? 'Add 1 more tank, it’s FREE' : 'Add 2 more tanks, your 3rd is FREE', colour: colours[H.tank] });
    }
    if (mixQty > 0 && mixQty < 4) {
      var next = mixQty + 1;
      var pct = MIX_TIERS[next];
      var pick;
      if ((qty[H.tee] || qty[H.ls]) && !qty[H.shorts]) pick = H.shorts;
      else if (qty[H.shorts] && !qty[H.tee]) pick = H.tee;
      else if (!qty[H.ls]) pick = H.ls;
      else if (!qty[H.tee]) pick = H.tee;
      else pick = H.shorts;
      offers.push({ handle: pick, kind: 'mix', pct: pct, tag: pct + '% off',
        msg: next === 2 ? 'Add any 1 more, get 10% off both' : ('Add 1 more, get ' + pct + '% off all ' + next), colour: colours[pick] || anyColour });
    }
    if (!offers.length) {
      if (mixQty >= 4) offers.push({ handle: (qty[H.mesh] ? H.tank : H.mesh), kind: 'plain', tag: 'Complete the fit', msg: 'Round out your kit', colour: anyColour });
      else offers.push({ handle: H.tee, kind: 'plain', tag: 'Best seller', msg: 'Add 2+ Conquer pieces for up to 20% off', colour: anyColour });
    }
    if (offers.length < 2 && !qty[H.tank] && !qty[H.mesh] && offers[0].handle !== H.tank) {
      offers.push({ handle: H.tank, kind: 'tankTwo', tag: 'Buy 2 get 1 free', msg: 'Buy 2 Essentials Tanks, get the 3rd FREE', colour: anyColour });
    }
    return { offers: offers.slice(0, 2), ctx: ctx };
  }

  function priceFor(offer, v){
    if (offer.kind === 'meshTank') return { was: v.price, now: Math.max(0, v.price - MESH_TANK_OFF) };
    if (offer.kind === 'tankFree') return { was: v.price, now: 0 };
    if (offer.kind === 'mix') return { was: v.price, now: Math.round(v.price * (100 - offer.pct) / 100) };
    return { was: null, now: v.price };
  }

  var LINE_SEL = 'cart-item, .cart-item, [class*="cart-item"], [class*="line-item"], cart-items, .fu-up';
  function findRecs(drawer){
    var head = null;
    var nodes = drawer.querySelectorAll('h2, h3, h4, h5, p, span, div, strong');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length === 0 && /you may also like/i.test(n.textContent)) { head = n; break; }
    }
    if (!head) return drawer.querySelector('product-recommendations, cart-recommendations, complementary-products');
    var el = head;
    while (el.parentElement && el.parentElement !== drawer) {
      var p = el.parentElement;
      if (p.querySelector(LINE_SEL)) break;
      el = p;
    }
    return el;
  }

  var lastSig = '', upTmr, drawing = false;
  function scheduleUpsell(){ clearTimeout(upTmr); upTmr = setTimeout(drawUpsell, 120); }
  function drawUpsell(){
    var drawer = document.querySelector('cart-drawer');
    var cart = lastCart;
    if (!drawer || !cart || drawing) return;
    var recs = findRecs(drawer);
    if (recs && !recs.classList.contains('fu-up')) recs.classList.add('fu-up-hidden');
    var existing = drawer.querySelector('.fu-up');
    var realItems = cart.items.filter(function(i){ return !isGift(i); }).length;
    if (!realItems) { if (existing) existing.remove(); showGiftDebug(); return; }
    var sig = cart.total_price + ':' + cart.items.map(function(i){ return i.key + 'x' + i.quantity; }).join(',');
    if (existing && sig === lastSig) { showGiftDebug(); return; }
    lastSig = sig;
    drawing = true;
    var plan = decide(cart);
    Promise.all(plan.offers.map(function(o){ return getP(o.handle); })).then(function(products){
      drawing = false;
      var wrap = document.createElement('div');
      wrap.className = 'fu-up';
      wrap.innerHTML = '<p class="fu-up-title">Unlock more with your order</p>';
      plan.offers.forEach(function(o, idx){ var p = products[idx]; if (p) wrap.appendChild(card(o, p, plan.ctx)); });
      if (!wrap.querySelector('.fu-up-card')) return;
      var d = document.querySelector('cart-drawer'); if (!d) return;
      var cur = d.querySelector('.fu-up');
      var r2 = findRecs(d);
      if (cur) cur.replaceWith(wrap);
      else if (r2 && r2.parentNode) r2.parentNode.insertBefore(wrap, r2);
      else {
        var items = d.querySelector('cart-items, .cart-items, [class*="cart-items"], .drawer__scrollable, .drawer__content');
        if (items) items.appendChild(wrap);
      }
      showGiftDebug();
    }).catch(function(){ drawing = false; });
  }

  function card(o, p, ctx){
    var ci = optIdx(p, /colou?r/i), si = optIdx(p, /size/i);
    var colours = [];
    if (ci > -1) p.variants.forEach(function(v){ var c = v['option' + (ci + 1)]; if (colours.indexOf(c) === -1) colours.push(c); });
    var colour = null;
    if (ci > -1) {
      if (o.colour && colours.indexOf(o.colour) > -1) colour = o.colour;
      if (!colour) {
        for (var i = 0; i < colours.length; i++) {
          var ok = p.variants.some(function(v){ return v['option' + (ci + 1)] === colours[i] && v.available; });
          if (ok) { colour = colours[i]; break; }
        }
      }
      colour = colour || colours[0];
    }
    var el = document.createElement('div');
    el.className = 'fu-up-card';
    el.innerHTML =
      '<a class="fu-up-img" href="' + p.url + '"><img alt="" loading="lazy"></a>' +
      '<div class="fu-up-info">' +
        '<span class="fu-up-tag"></span>' +
        '<a class="fu-up-name" href="' + p.url + '"></a>' +
        '<div class="fu-up-price"></div>' +
        '<div class="fu-up-msg"></div>' +
        '<div class="fu-up-ship"></div>' +
        '<div class="fu-up-row">' +
          (ci > -1 && colours.length > 1 ? '<select class="fu-up-colour" aria-label="Colour"></select>' : '') +
          (si > -1 ? '<select class="fu-up-size" aria-label="Size"></select>' : '') +
          '<button type="button" class="fu-up-add">Add</button>' +
        '</div>' +
        '<div class="fu-up-err"></div>' +
      '</div>';
    el.querySelector('.fu-up-tag').textContent = o.tag;
    el.querySelector('.fu-up-name').textContent = p.title;
    el.querySelector('.fu-up-msg').textContent = o.msg;
    var img = el.querySelector('img');
    var cSel = el.querySelector('.fu-up-colour');
    var sSel = el.querySelector('.fu-up-size');
    var btn = el.querySelector('.fu-up-add');
    var err = el.querySelector('.fu-up-err');

    if (cSel) colours.forEach(function(c){ var op = document.createElement('option'); op.value = c; op.textContent = c; if (c === colour) op.selected = true; cSel.appendChild(op); });

    function variantsForColour(){
      if (ci < 0) return p.variants;
      var c = cSel ? cSel.value : colour;
      return p.variants.filter(function(v){ return v['option' + (ci + 1)] === c; });
    }
    function fillSizes(){
      if (!sSel) return;
      var prev = sSel.value;
      sSel.innerHTML = '';
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Size'; sSel.appendChild(ph);
      variantsForColour().forEach(function(v){
        var op = document.createElement('option');
        op.value = v.id;
        op.textContent = v['option' + (si + 1)] + (v.available ? '' : ' - Sold out');
        op.disabled = !v.available;
        var want = prev ? null : ctx.size;
        if (v.available && ((prev && String(v.id) === prev) || (want && v['option' + (si + 1)] === want))) op.selected = true;
        sSel.appendChild(op);
      });
    }
    function current(){
      var vs = variantsForColour();
      if (sSel) { var id = sSel.value; return vs.filter(function(v){ return String(v.id) === id; })[0] || null; }
      return vs.filter(function(v){ return v.available; })[0] || vs[0];
    }
    function paint(){
      var vs = variantsForColour();
      var v = current() || vs[0] || p.variants[0];
      var fi = (v && v.featured_image && v.featured_image.src) || (vs[0] && vs[0].featured_image && vs[0].featured_image.src) || p.featured_image;
      if (fi) img.src = (fi.indexOf('//') === 0 ? 'https:' + fi : fi) + (fi.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      var pr = priceFor(o, v);
      el.querySelector('.fu-up-price').innerHTML = (pr.was !== null && pr.was !== pr.now ? '<s>' + money(pr.was) + '</s>' : '') + '<b>' + (pr.now === 0 ? 'FREE' : money(pr.now)) + '</b>';
      var gap = FREE_SHIP - ctx.sub;
      el.querySelector('.fu-up-ship').textContent = (gap > 0 && pr.now >= gap) ? 'Also unlocks FREE standard shipping' : '';
    }
    fillSizes();
    paint();
    if (cSel) cSel.addEventListener('change', function(){ fillSizes(); paint(); });
    if (sSel) sSel.addEventListener('change', paint);

    btn.addEventListener('click', function(){
      var v = current();
      err.textContent = '';
      if (!v) { err.textContent = 'Please choose a size'; if (sSel) sSel.focus(); return; }
      if (!v.available) { err.textContent = 'That size is sold out'; return; }
      btn.disabled = true;
      btn.textContent = '...';
      postJSON('/cart/add.js', { items: [{ id: Number(v.id), quantity: 1 }] })
        .then(function(){ btn.classList.add('is-done'); btn.textContent = '✓'; return refreshCart(); })
        .then(function(c){ if (c) syncGift(c); })
        .catch(function(e){ btn.disabled = false; btn.textContent = 'Add'; err.textContent = (e && e.message) || 'Could not add, please try again'; });
    });
    return el;
  }

  /* ---------- C) safety net for remove / quantity change ---------- */
  function rowQty(key){
    var inp = null;
    try { inp = document.querySelector('input[data-index="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]'); } catch (e) {}
    var q = inp ? parseInt(inp.defaultValue || inp.getAttribute('value') || '', 10) : NaN;
    return isNaN(q) ? 1 : q;
  }
  function repairChange(key, want, oldQty){
    var variant = Number(String(key).split(':')[0]);
    return getCart().then(function(cart){
      var exact = cart.items.filter(function(i){ return i.key === key; })[0];
      var lines = cart.items.filter(function(i){ return i.variant_id === variant; });
      var updates = {};
      if (exact) updates[exact.key] = want;
      else if (lines.length) {
        var delta = want - oldQty;
        if (delta > 0) updates[lines[0].key] = lines[0].quantity + delta;
        else {
          var left = -delta;
          for (var i = lines.length - 1; i >= 0 && left > 0; i--) {
            var take = Math.min(lines[i].quantity, left);
            updates[lines[i].key] = lines[i].quantity - take;
            left -= take;
          }
        }
      }
      return cartUpdate(updates);
    });
  }
  function cleanCart(){
    return cartUpdate({}).catch(function(){ return wait(3000).then(function(){ return cartUpdate({}); }); })
      .catch(function(){ var c = lastCart ? JSON.parse(JSON.stringify(lastCart)) : { items: [], item_count: 0, total_price: 0 }; c.sections = {}; return c; });
  }
  var recovering = false;
  var BACKOFF = [600, 1200, 2000, 3000, 4000];
  function recover(ev){
    if (recovering) return;
    recovering = true;
    var key = String(ev.line || '');
    var want = ev.target ? Math.max(0, parseInt(ev.target.value, 10) || 0) : 0;
    var oldQty = rowQty(key);
    note('recovering key ' + key.slice(0, 18) + ' want ' + want);
    function once(){ return key.indexOf(':') > -1 ? repairChange(key, want, oldQty) : cartUpdate({}); }
    function attempt(n){
      return wait(BACKOFF[n]).then(once).catch(function(e){
        note('retry ' + (n + 1) + ' failed: ' + (e && e.message));
        return n + 1 < BACKOFF.length ? attempt(n + 1) : cleanCart();
      });
    }
    attempt(0).catch(function(){ return null; }).then(function(cart){
      note('recovery done: ' + (isCart(cart) ? cart.item_count + ' items' : 'no cart'));
      try {
        setCart(cart);
        if (cart && cart.sections && Object.keys(cart.sections).length) {
          try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fu-cart', cart: cart }); }
          catch (e) { swapSections(cart); }
        }
        if (isCart(cart)) syncGift(cart);
      } finally {
        recovering = false;
        document.querySelectorAll('cart-items [id^="Loader-"]').forEach(function(l){ l.hidden = true; });
      }
    });
  }
  function patchCartItems(){
    var C = window.customElements && customElements.get('cart-items');
    if (!C || C.prototype.__fuPatched) return;
    C.prototype.__fuPatched = true;
    var origErr = C.prototype.onCartError;
    C.prototype.onCartError = function(errors, target){
      if (/no valid id or line|cannot find|too many|try again|bad_request/i.test(String(errors))) {
        try { if (target) this.disableLoading(target.getAttribute('data-index')); } catch (e) {}
        return;
      }
      if (!target) return;
      return origErr.apply(this, arguments);
    };
  }
  if (window.customElements) {
    patchCartItems();
    customElements.whenDefined('cart-items').then(patchCartItems);
  }

  /* ---------- keep the gift in sync with changes made elsewhere ---------- */
  var fetchTmr, lastNet = 0;
  function syncFromServerSoon(){
    clearTimeout(fetchTmr);
    fetchTmr = setTimeout(function(){ lastNet = Date.now(); getCart().then(syncGift).catch(function(){}); }, 350);
  }
  var JUNK_ERR = /no valid id or line|cannot find|too many|try again|bad_request|429/i;
  function listen(){
    if (!(window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.publish && theme.pubsub.PUB_SUB_EVENTS)) return false;
    if (theme.pubsub.__fu) return true;
    theme.pubsub.__fu = true;
    var CU = theme.pubsub.PUB_SUB_EVENTS.cartUpdate;
    var origPublish = theme.pubsub.publish;
    theme.pubsub.publish = function(evt, data){
      if (evt === CU && data && data.source === 'cart-items') {
        var c = data.cart;
        try { note('remove/qty -> ' + (isCart(c) ? ('OK, sections ' + (c.sections ? Object.keys(c.sections).join(',') : 'MISSING')) : ('FAILED ' + JSON.stringify(c).slice(0, 140)))); } catch (e) {}
        var good = isCart(c) && c.sections;
        var realError = c && c.errors && data.target && !JUNK_ERR.test(String(c.errors));
        if (!good && !realError) { recover(data); return; }
      }
      return origPublish.apply(this, arguments);
    };
    theme.pubsub.subscribe(CU, function(ev){
      if (!ev || ev.source === 'fu-cart') { scheduleUpsell(); return; }
      if (isCart(ev.cart)) { setCart(ev.cart); setTimeout(function(){ syncGift(ev.cart); }, 50); }
      else syncFromServerSoon();
    });
    return true;
  }

  function start(){
    injectCss();
    note('script v5 loaded, theme events ' + (window.theme && theme.pubsub ? 'found' : 'MISSING'));
    patchCartItems();
    if (!listen()) setTimeout(listen, 800);
    lastNet = Date.now();
    getCart().then(syncGift).catch(function(e){ note('cart read failed: ' + (e && e.message)); });
    window.addEventListener('pageshow', function(e){ if (e.persisted) syncFromServerSoon(); });
    if (!window.MutationObserver) return;
    new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.target && m.target.closest && m.target.closest('.fu-up, .fu-gift-debug')) continue;
        var nodes = m.addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1 || (n.classList && (n.classList.contains('fu-up') || n.classList.contains('fu-gift-debug')))) continue;
          if (n.tagName === 'CART-DRAWER' || (n.closest && n.closest('cart-drawer')) || (n.querySelector && n.querySelector('cart-drawer'))) {
            lastSig = ''; scheduleUpsell();
            if (Date.now() - lastNet > 3000 && !giftBusy) syncFromServerSoon();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
